import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { COMPANY } from "../lib/data";
import Reveal from "./Reveal";
import QuoteForm from "./QuoteForm";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="rounded-[2rem] bg-slate-50 border border-slate-200 p-6 md:p-12 grid lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <Reveal><span className="overline">Devis & Urgences</span></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
                Besoin d&apos;aide <span className="gradient-text">maintenant&nbsp;?</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-5 text-lg text-ink-soft max-w-md leading-relaxed">
                Pour une urgence, appelez-nous : un technicien répond en moins de 2 minutes. Sinon,
                laissez vos coordonnées et nous vous rappelons rapidement.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <a href={COMPANY.phoneHref} data-testid="contact-call-btn" className="btn-primary mt-8">
                <Phone className="h-4 w-4" /> {COMPANY.phone}
              </a>
            </Reveal>
            <Reveal delay={0.4}>
              <ul className="mt-10 space-y-4">
                {[
                  { icon: Mail, text: COMPANY.email },
                  { icon: MapPin, text: COMPANY.zone },
                  { icon: Clock, text: COMPANY.hours },
                ].map((it, idx) => {
                  const Icon = it.icon;
                  return (
                    <li key={idx} className="flex items-center gap-4 text-ink-soft">
                      <span className="h-10 w-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center">
                        <Icon className="h-4 w-4 text-brand" />
                      </span>
                      {it.text}
                    </li>
                  );
                })}
              </ul>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="bg-white rounded-2xl border border-slate-200 shadow-lg shadow-slate-200/50 p-6 md:p-8">
              <QuoteForm source="accueil" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
